import React, {useEffect, useState} from 'react';

import './App.css';
import emailjs from "emailjs-com";
import "animate.css/animate.min.css";
import { useAlert } from 'react-alert'
import './fonts/Circular Std Black.ttf';
import './fonts/Circular Std Bold.ttf';
import './fonts/Circular Std Book.ttf';


let counter = 0;
const sloganList = ['Taking the pain out of date night.', 'Picking a restaurant just got easier.', 'Eating out has never been easier.'];

function App() {

  const alert = useAlert();
  const [slogan, setSlogan] = useState("Eating out has never been easier.");
 


 function sendEmail(e) {
  e.preventDefault();
  
  console.log(e.target.from_name.value)
  if(e.target.from_name.value.length < 1 || e.target.from_name.value.length >= 50) {
    alert.error("Please enter your email or phone number!");
  } else {
    emailjs.sendForm('gmail', 'template_jHDXlC2P', e.target, 'user_0j42qXSOGfzDApSxQuEr3')
      .then((result) => {
          console.log(result.text);
          alert.success("WE have successfully recieved your request!");
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset()
  }

}



useEffect(() => {
  

// // Run an setInterval every 5 seconds  
setInterval(() => {
 counter++;
 if (counter === 3) {
   counter = 0;
 }

 setSlogan(sloganList[counter]);

}, 5000);


}, []);




  return (

    <div className="Home">
    
    <div className="intro-section">
      
      <div className="flex-column intro-section-content-wrap">
     
     
        
    <div className="main-content-container">

    <div className="logo-wrap">
    <img alt="" className="logoImg" src={require('./logo.svg')}></img>
      <span className="feedme-txt">FeedMe</span>
    </div>
       
    <h1  className="fade-in" style={{fontFamily: 'Circular Std Bold'}}>{slogan}</h1>
       


<div style={{display: 'flex', flexFlow: 'row',  alignItems: 'center'}}>
    <div className="email-input-wrap " style={{marginBottom: 40, marginTop: 40}}>
      <a href="https://testflight.apple.com/join/7cjrB3qO">
        <button className="emailUpdateBtn " style={{fontFamily: 'Circular Std Bold', marginBottom: 25 }}>Test IOS Beta</button>
      </a>

      {/* <a href="https://play.google.com/apps/testing/com.hadiaamir.feedmeai" className="android-btn">
        <button className="emailUpdateBtn " style={{fontFamily: 'Circular Std Bold'}}>Test Android Beta</button>
        </a> */}
    </div>

</div>


  

{/*        
    
      <form onSubmit={sendEmail} className="email-input-wrap mobile-hide">
          <input
            type="text"
            className="emailUpdateInput"
            placeholder="Enter your email or phone number"
            name="from_name"
            style={{fontFamily: 'Circular Std Book'}}
          ></input>
          <button type="submit" className="emailUpdateBtn mobile-hide" style={{fontFamily: 'Circular Std Bold'}}>Notify Me!</button>
      </form> */}
    
 
  
      {/* <form onSubmit={sendEmail} className="email-input-wrap ">
          <input 
                type="text"
                  className="mobileInput mobile-display"
                  placeholder="Enter your email or phone"
                  name="from_name"
                  style={{fontFamily: 'Circular Std Book'}}
            ></input>
            <button type="submit" className="emailUpdateBtn mobile-display" style={{fontFamily: 'Circular Std Bold'}}>Notify Me!</button>
      </form> */}
    



      </div>
    
  

      </div>
        <img alt="" className="homeIphoneImg mobile-img-hide" src={require('./winnerPhone.png')}></img>
      
    </div>


   
    <div className="wrapper-3">
    <img alt="" className="mainImg" src={require('./pickCuisine.png')}></img>
    <div className="flex-column picture-desc-wrap">
      <h2 className="pic-desc-h2">Every tastebud is different.</h2>
      <p className="pic-desc-para">Whether it’s date night with that special someone, or fight night with the boys, everybody’s craving something different. Settle those heated debates with FeedMe! Powered by AI, your preferences and machine learning,  FeedMe curates personalized selections for your group.</p>
    </div>
    </div>
 

    
    <div className="wrapper-2">
    <img alt="" className="mainImg" src={require('./dash.png')}></img>
    <img alt="" className="mainImg" src={require('./tinder.png')}></img>
    <div className="flex-column picture-desc-wrap">
      <h2 className="pic-desc-h2">Know the Who, What, When, Where and Why</h2>
      <p className="pic-desc-para">As you visit more restaurants, FeedMe utilizes your recent history to pick more restaurants that best fit your needs. Not only that, but FeedMe is constantly working to find out who to go with, what to eat, when to eat it, where to eat it, and why that suggestion is the best pick for the moment. </p>
    </div>
  
    </div>

    
    
    <div className="wrapper-3">
    <img alt="" className="mainImg" src={require('./mapsView.png')}></img>
    <div className="flex-column picture-desc-wrap">
      <h2 className="pic-desc-h2">Seamlessly integrating takeout delivery from your favourite apps.</h2>
      <p className="pic-desc-para">Like what FeedMe has picked for you? Check out menus, reviews, photos, and real-time restaurant content. Don’t feel like dressing up and getting out? Dress down, and click on your favourite food delivery courier, and FeedMe will take you to their order page!</p>
    </div>
 
    </div>
    
    

    <div className="footer">
      <div className="email-input-outer">
    <p className="pic-footer-para" style={{textAlign: 'left', marginLeft: '10px', fontFamily: 'Circular Std Bold'}}>We just launched our beta, test it out on IOS!</p>
        
        
        
        
        
        
        
{/*         
        <form onSubmit={sendEmail} className="email-input-wrap footerInput-wrap mobile-hide">
          <input 
           type="text"
            className="emailUpdateInput"
            placeholder="Enter your email or phone number"
            name="from_name"
            style={{fontFamily: 'Circular Std Book'}}
          ></input>
          <button className="emailUpdateBtn mobile-hide">Notify Me!</button>
        </form> */}


  
{/* 
<div className="email-input-wrap" style={{marginBottom: 40, marginTop: 40}}>
        <a href="https://testflight.apple.com/join/7cjrB3qO">
  <button className="emailUpdateBtn " style={{fontFamily: 'Circular Std Bold'}}>Test IOS Beta</button>
  </a>
</div>


<div className="email-input-wrap" style={{marginBottom: 40, marginTop: 40}}>
        <a href="https://play.google.com/apps/testing/com.hadiaamir.feedmeai">
  <button className="emailUpdateBtn " style={{fontFamily: 'Circular Std Bold'}}>Test Android Beta</button>
  </a>
</div> */}


<div style={{display: 'flex', flexFlow: 'row',  alignItems: 'center'}}>
    <div className="email-input-wrap " style={{marginBottom: 40, marginTop: 40}}>
      <a href="https://testflight.apple.com/join/7cjrB3qO">
        <button className="emailUpdateBtn " style={{fontFamily: 'Circular Std Bold', marginBottom: 25 }}>Test IOS Beta</button>
      </a>

      {/* <a href="https://play.google.com/apps/testing/com.hadiaamir.feedmeai" className="android-btn">
        <button className="emailUpdateBtn " style={{fontFamily: 'Circular Std Bold'}}>Test Android Beta</button>
        </a> */}
    </div>

</div>






        {/* <form onSubmit={sendEmail} className="email-input-wrap footerInput-wrap ">
          <input 
           type="text"
            className="mobileInput"
            placeholder="Enter your email or phone"
            name="from_name"
            style={{fontFamily: 'Circular Std Book'}}
          ></input>
          <button className="emailUpdateBtn mobile-display">Notify Me!</button>
        </form> */}

{/* 
        <form onSubmit={sendEmail} className="email-input-wrap footerInput-wrap ">
            <input 
                type="text"
                  className="mobileInput"
                  placeholder="Enter your email or phone"
                  name="from_name"
            ></input>
            <button type="submit" className="emailUpdateBtn  ">Submit</button>

        </form> */}
       



        </div>


       








       


   <div className="logo-outer-wrap">
     <div className="logo-wrap-footer">
    <img alt="" className="logoImg" src={require('./logo.svg')}></img>
      <span className="feedme-txt">FeedMe</span>
      </div>

      {/* <div className="store-wrap">
      <small className="coming-soon-txt" style={{fontFamily: 'Circular Std Bold'}}>Coming Soon on...</small>
       <div>
      <img alt="" className="store-logo" src={require('./appstore.svg')}></img>
      <img alt="" className="store-logo android-logo" src={require('./unnamed.png')}></img>
      </div>
   </div> */}
    </div>

       
    </div>
    
   
    
    </div>
   
  );
}

export default App;
